import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";

import { Controller, useForm } from "react-hook-form";
import RazorPay from "../../components/RazorPay";
import { useSelector } from "react-redux";
import LoginPopup from "../../components/LoginPopup";
import { useState } from "react"
import { getAllCities, guideBooking } from "../../apis"
import { useNavigate, useParams } from "react-router-dom"
import { useFetch } from "../../hooks/useFetch";



export default ({ guide = {}}) => {
    const params = useParams()
    const navigate = useNavigate()

    const { customer, isLoggedIn } = useSelector( state => state.auth )
    const [modal, setModal] = useState({ open: false });
    const { register, handleSubmit, control, getValues, watch } = useForm({ onChange: true })

    const [ razorpay, setRazorpay ] = useState({ amountToPay: 0, bookingId: null, orderId: null })

    const [cities] = useFetch(getAllCities, [])
    const totalBookingHours = watch("totalBookingHours")



    const submit = async ( data ) => {
        try {
            data.guideId = params.guideId    
            data.bookingTimeFrom = new Date( data.bookingDate).toLocaleTimeString([], { hour12: false, hour: "2-digit", minute: "2-digit" })        
            
            const bookingTimeTo = new Date( data.bookingDate )
            bookingTimeTo.setHours(bookingTimeTo.getHours() + +data.totalBookingHours )

            console.log('bookingTimeTo', bookingTimeTo.getHours() + +data.totalBookingHours, bookingTimeTo )
            data.bookingTimeTo = bookingTimeTo.toLocaleTimeString([], { hour12: false, hour: "2-digit", minute: "2-digit" })        
            
            data.bookingDate = new Date(data.bookingDate).toLocaleDateString()
            data.discountPrice = 0
            data.paidAmount = 1 || guide.pricePerHour
            data.paymentMethod = "online"

            const response = await guideBooking(data)
            console.log('>>>>>>>>>', response)

            if( !isLoggedIn ){
                setModal({ open: true })
                window.localStorage.setItem("pendingpayment", JSON.stringify({ 
                    amountToPay: response.amountToPay,
                    bookingId: response.bookingId,
                    orderId: response.razorpayOrderId
                }))
                return
            }

            setRazorpay({ 
                amountToPay: response.amountToPay,
                bookingId: response.bookingId,
                orderId: response.razorpayOrderId
            })
            localStorage.setItem("guide", JSON.stringify(response))
        } catch (error) {
            console.log("error", error)
        }
    }


    return (
        <>
            <form onSubmit={handleSubmit(submit)} className="card rounded-4 p-4 mt-5">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <p className="mb-1">Price</p>
                        <h5>Per Hour</h5>
                    </div>
                    <div>
                        <p></p>
                        <h5 className="text-saffron">₹{guide.pricePerHour}</h5>
                    </div>
                </div>
                <hr className="mb-4 mt-0" />
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p className="bold mb-0">Date</p>
                        <Controller
                            name="bookingDate"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) =>
                                <DatePicker
                                    {...field}
                                    selected={getValues("bookingDate")}
                                    placeholderText="Check In"
                                    className="input-2 border-bottom"
                                    minDate={new Date()}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                />
                            }

                        />
                        <hr className="mb-4 mt-0" />
                    </div>
                    <div className="col">
                        <p className="bold mb-0">Time</p>
                        <select className="borderless w-100" {...register("totalBookingHours", { required: true })}>
                            {
                                Array(24).fill(0).map((hr, i) =>
                                    <option value={i + 1}>{i + 1} hrs &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</option>
                                )
                            }
                        </select>
                        <hr className="mb-3 mt-0" />
                    </div>
                </div>

                <label className="bold">Location</label>
                <select className="borderless" {...register("cityId", { required: true })}>
                    <option>Select Location</option>
                    {cities?.map((city, i) => <option key={i} value={city._id}>{city.name}</option>)}
                </select>
                <hr />

                <label className="bold">No of travellers</label>
                <select className="borderless" {...register("NoOftravellers", { required: true })}>
                    <option>6 guests, 1 kid</option>
                </select>
                <hr />

                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <p className="mb-0 fs-8"> ₹{guide.pricePerHour} x {totalBookingHours} per night</p>
                    </div>
                    <div>
                        <p className="bold text-saffron fs-5 mb-0">₹{guide.pricePerHour * totalBookingHours}</p>
                    </div>
                </div>
                <div>
                    <button type="submit" className="search-button mt-4 w-100">Book Now</button>
                </div>
            </form>

            {modal.open && <LoginPopup open={modal.open} setOpen={setModal} cb={ data => console.log('data', data)} />}
            {<RazorPay amount={razorpay.amountToPay} bookingId={razorpay.bookingId} orderId={razorpay.orderId} customer={customer} cb={(type, response) => (console.log('razorpaycb', type, response), setRazorpay({})) } />}
        
        </>
    )
}